export default {
    add_new_topic: "Agregar nuevo tema",
    confirm_delete_reply: "¿Estás seguro de que deseas eliminar tu respuesta?",
    confirm_delete_topic: "¿Estás seguro de que deseas eliminar el tema?",
    delete_reply: "Eliminar respuesta",
    delete_topic: "Eliminar tema",
    delete: "Eliminar",
    edit: "Editar",
    error_changing_answer_status: "Error al cambiar el status de respuesta",
    error_changing_topic_status: "Error al cambiar el estado del tema",
    error_deleting_reply: "Error al eliminar la respuesta",
    error_deleting_topic: "Error al eliminar el tema",
    error_editing_reply: "Error al cambiar la respuesta",
    error_editing_topic: "Error al eliminar el tema",
    in_this_course: "en este curso",
    reply_deleted: "Respuesta despejada",
    reply_edited: "La respuesta ha cambiado",
    search_topic: "Buscar tema",
    there_are_no_topics_in_this_course_yet: "Aún no hay temas en este curso",
    topic_added_successfully: "Tema agregado con éxito",
    topic_deleted: "Tema eliminado",
    topic_edited: "Tema editado",
    topic_is_closed: "Este tema está cerrado y no acepta más respuestas.",
    topic_plural: "temas",
    topic: "tema",
}
